// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__Vpb5R","notFound":"NotFound_notFound__BEDid"};